import React from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';


const RedirectToFirstAccount = ({ accountNumber }) => (
  accountNumber && <Redirect push={false} to={`/portfolio/${accountNumber}`} />
);

const mapStateToProps = state => ({
  accountNumber: state.currentAccount,
});

export default connect(mapStateToProps)(RedirectToFirstAccount);



// WEBPACK FOOTER //
// ./src/components/Portfolio/RedirectToFirstAccount.js